// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1j6d9","name":"ConsentHeader_name__1bI2R","birthday":"ConsentHeader_birthday__dh3WD","skeleton":"ConsentHeader_skeleton__1VE2l"};